import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { RouterLink } from '@angular/router';

import { SharedModule } from '../../../../../shared.module';
import { GroupMenuModule } from '../../group-menu/group-menu.module';
import { HeaderMenuMilestoneModule } from '../../header-menu-milestone/header-menu-milestone.module';
import { KpiTableCardComponent } from './kpi-table-card.component';

@NgModule({
  declarations: [KpiTableCardComponent],
  exports: [KpiTableCardComponent],
  imports: [
    MatTableModule,
    MatMenuModule,
    SharedModule,
    RouterLink,
    OverlayModule,
    CommonModule,
    HeaderMenuMilestoneModule,
    GroupMenuModule
  ]
})
export class KpiTableCardModule {}
